import { render, staticRenderFns } from "./Economy.vue?vue&type=template&id=0a8b60cc&scoped=true&"
import script from "./Economy.vue?vue&type=script&lang=js&"
export * from "./Economy.vue?vue&type=script&lang=js&"
import style0 from "./Economy.vue?vue&type=style&index=0&id=0a8b60cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8b60cc",
  null
  
)

export default component.exports